/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CapturePaymentResponse
 */
export interface CapturePaymentResponse {
    /**
     * Stripe PaymentIntent id (`pi_xxx`).
     * @type {string}
     * @memberof CapturePaymentResponse
     */
    paymentIntentId: string;
    /**
     * Stripe PaymentIntent.status after capture.
     * @type {string}
     * @memberof CapturePaymentResponse
     */
    status?: string | null;
    /**
     * Captured amount in minor units.
     * @type {number}
     * @memberof CapturePaymentResponse
     */
    amountCents: number;
    /**
     * ISO currency code echoed back from Stripe.
     * @type {string}
     * @memberof CapturePaymentResponse
     */
    currency: string;
    /**
     * True iff `status == "succeeded"`.
     * @type {boolean}
     * @memberof CapturePaymentResponse
     */
    succeeded: boolean;
}

/**
 * Check if a given object implements the CapturePaymentResponse interface.
 */
export function instanceOfCapturePaymentResponse(value: object): value is CapturePaymentResponse {
    if (!('paymentIntentId' in value) || value['paymentIntentId'] === undefined) return false;
    if (!('amountCents' in value) || value['amountCents'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('succeeded' in value) || value['succeeded'] === undefined) return false;
    return true;
}

export function CapturePaymentResponseFromJSON(json: any): CapturePaymentResponse {
    return CapturePaymentResponseFromJSONTyped(json, false);
}

export function CapturePaymentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CapturePaymentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentIntentId': json['payment_intent_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'amountCents': json['amount_cents'],
        'currency': json['currency'],
        'succeeded': json['succeeded'],
    };
}

export function CapturePaymentResponseToJSON(json: any): CapturePaymentResponse {
    return CapturePaymentResponseToJSONTyped(json, false);
}

export function CapturePaymentResponseToJSONTyped(value?: CapturePaymentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_intent_id': value['paymentIntentId'],
        'status': value['status'],
        'amount_cents': value['amountCents'],
        'currency': value['currency'],
        'succeeded': value['succeeded'],
    };
}

